export const routesConfig = [
  {
    path: '/login',
    component: 'Login',
  },
  {
    path: '/dashboard',
    component: 'Dashboard',
  },
  {
    path: '/presentation',
    component: 'productos/Presentation',
  },
  {
    path: '/brand',
    component: 'productos/Brand',
  },
  {
    path: '/tax',
    component: 'productos/Tax',
  },
  {
    path: '/invoice',
    component: 'Cotizacion/Invoice',
  },
  {
    path: '/reportes',
    component: 'Reportes/Reportes',
  },
  {
    path: '/factura',
    component: 'factura/Factura',
  },
  {
    path: '/category',
    component: 'productos/Category', 
  },
  {
    path: '/purchase', 
    component: 'compras/Compra', 
  },
  {
    path: '/warehouse', 
    component: 'productos/Warehouses', 
  },

  // ==========================================
  // RUTAS MODIFICADAS (Sincronizadas con tus carpetas)
  // ==========================================

  // --- MÓDULO CLIENTES ---
  {
    path: '/customer',
    component: 'clientes/Customer',
  },
  // NUEVO: Ruta para Empresas
  {
    path: '/empresas',
    component: 'Setting/Empresas', 
  },

 {
  path: '/vendedores', // Plural
  component: 'clientes/Vendedor', 
},
  // NUEVO: Ruta para Sectores
  {
    path: '/sector',
    component: 'clientes/Sector', 
  },
  {
    path: '/cxc',
    component: 'clientes/TransaccionesCliente',
  },
  {
    path: '/operationtype',
    component: 'clientes/TipoOperacionCliente', 
  },

  // --- MÓDULO PROVEEDORES ---
  {
    path: '/supplier',
    component: 'provedores/Provedores',
  },
  {
    path: '/cxp',
    component: 'provedores/TransaccionesProvedor', 
  },
  {
    path: '/provideroperationtype',
    component: 'provedores/TipoOperacionProvedor',
  },

  // --- MÓDULO PRODUCTOS ---
  {
    path: '/product',
    component: 'productos/Product',
  },
  {
    path: '/transaction', 
    component: 'productos/TransactionProduct',
  },
  {
    path: '/productoperationtype',
    component: 'productos/TipoOperacionProducto',
  },


 {
    path: '/settings',
    component: 'Settings/Settings', // <-- Apuntamos al contenedor principal
  },
   {
    path: '/settingsAi',
    component: 'SettingsAi/SettingsAi', // <-- Apuntamos al contenedor principal
  },
];